
import React from "react";
import "./ShareButtonIcon.css";

interface ShareButtonIconProps {
  size?: number;
  className?: string;
  color?: string;
}

/**
 * Unified share icon used across post, list, itinerary, place, profile,
 * and recommendation share surfaces. Uses the platform's custom paper-airplane
 * SVG for a consistent share visual across all surfaces.
 */
const ShareButtonIcon: React.FC<ShareButtonIconProps> = ({
  size = 20,
  className,
  color = "#252528",
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className ? `share-button-icon ${className}` : "share-button-icon"}
  >
    <path
      d="M19.5242 0.416667C19.3316 0.261736 19.0976 0.166883 18.8515 0.143916C18.6054 0.120949 18.358 0.170882 18.14 0.2875L0.890833 9.56667C0.611231 9.71683 0.379694 9.94286 0.222856 10.2188C0.0660179 10.4947 -0.00975081 10.8093 0.00426541 11.1263C0.0182816 11.4434 0.121513 11.7501 0.302086 12.011C0.482659 12.272 0.733238 12.4768 1.025 12.6017L3.72833 13.7608L5.59833 18.78C5.89 19.5633 7.0675 20.53 8.5225 19.2108L11.125 16.9308L13.4325 17.9167C13.6533 18.0111 13.8917 18.0574 14.1317 18.0523C14.3718 18.0473 14.608 17.991 14.8246 17.8874C15.0412 17.7837 15.2332 17.6351 15.3878 17.4513C15.5423 17.2675 15.6559 17.0528 15.7208 16.8217L19.9508 1.73667C20.0166 1.49903 20.0112 1.24733 19.9354 1.01271C19.8595 0.778099 19.7166 0.570869 19.5242 0.416667ZM5.39833 13.4708L10.75 10L7.16667 14.0442C7.06629 14.164 6.99804 14.3074 6.96833 14.4608L6.60833 16.7183L5.39833 13.4708ZM8.2075 17.2708L8.44667 15.7833L9.42667 16.2L8.2075 17.2708ZM14.1533 16.1592C14.1454 16.1878 14.1315 16.2143 14.1124 16.2371C14.0933 16.2598 14.0696 16.2782 14.0428 16.291C14.0161 16.3038 13.9868 16.3107 13.9572 16.3113C13.9275 16.3118 13.8981 16.306 13.8708 16.2942L9.44667 14.3983C9.41641 14.3854 9.38966 14.3654 9.36862 14.3401C9.34757 14.3147 9.33282 14.2848 9.32558 14.2527C9.31835 14.2206 9.31883 14.1872 9.32698 14.1553C9.33514 14.1234 9.35074 14.0939 9.3725 14.0692L16.0392 6.5225C16.1121 6.43642 16.1669 6.33657 16.2005 6.22888C16.234 6.12118 16.2456 6.00784 16.2345 5.89559C16.2234 5.78334 16.1898 5.67447 16.1358 5.57545C16.0817 5.47643 16.0084 5.38927 15.92 5.31917C15.7814 5.22062 15.6176 5.16378 15.4478 5.15537C15.278 5.14695 15.1093 5.18731 14.9617 5.27167L4.30333 12.1883L2.07 11.2067C2.03452 11.1908 2.00419 11.1653 1.98244 11.1331C1.96069 11.1009 1.94838 11.0632 1.94691 11.0244C1.94543 10.9856 1.95485 10.9471 1.9741 10.9133C1.99335 10.8796 2.02166 10.8519 2.05583 10.8333L18.0833 2.21L14.1533 16.1592Z"
      fill={color}
    />
  </svg>
);

export default ShareButtonIcon;
